const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const sendContactPageForm = async (userId = null, name, selectedCountry, phone, email, message, contact, line, wechat, reason, budget, type, category, area, landUnit, purpose, room) => {
    // console.log(name, selectedCountry, phone, email, message)

    let data = {
        userId,
        name,
        phonePrefix: selectedCountry,
        phone,
        email,
        message,
        preferredContact: contact.value,
        line,
        wechat,
        reason,
        budget,
        type,
        category: category?.value,
        area,
        landUnit: landUnit?.value,
        purpose,
        rooms: room?.value
    };

    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'Content-Type': 'application/json'
    }

    let url

    // if (reason.value == 'other') {
        url = `${baseUrl}/enquiry/contact`
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            cache: 'no-store',
            body: JSON.stringify(data)
        })

        const result = await response.json()
        return result
    // } else if (reason.value == 'sell') {
    //     url = `${baseUrl}/enquiry/sell`

    //     data['sale'] = 'sell/rent'

    //     console.log(data)

    //     const response = await fetch(url, {
    //         method: 'POST',
    //         headers: headers,
    //         cache: 'no-store',
    //         body: JSON.stringify(data)
    //     })

    //     const result = await response.json()
    //     return result
    // } else {
    //     url = `${baseUrl}/enquiry/personalizedservice`

    //     data['sale'] = reason.value


    //     const headers = {
    //         'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
    //         'Content-Type': 'application/json'
    //     }

    //     const response = await fetch(url, {
    //         method: 'POST',
    //         headers: headers,
    //         cache: 'no-store',
    //         body: JSON.stringify(data)
    //     })

    //     const result = await response.json()
    //     return result
    // }






}